import { render, staticRenderFns } from "./Layout4.vue?vue&type=template&id=70ecc463"
import script from "./Layout4.vue?vue&type=script&lang=js"
export * from "./Layout4.vue?vue&type=script&lang=js"
import style0 from "./Layout4.vue?vue&type=style&index=0&id=70ecc463&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports